const Background = (props) => {
  return <>{props.children}</>;
};
export default Background;
